export enum ProfileRole {
  Employee = 'employee',
  Dweller = 'dweller',
  Owner = 'owner',
  Tenant = 'tenant',
  Guest = 'guest',
  Manager = 'manager',
  Unknown = 'unknown',
}

export default ProfileRole;
